import { render, staticRenderFns } from "./SettingsSupport.vue?vue&type=template&id=511c00c0&scoped=true"
import script from "./SettingsSupport.vue?vue&type=script&lang=js"
export * from "./SettingsSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c00c0",
  null
  
)

export default component.exports